<template>
    <cic-popup
        id="edit_access_point_group"
        :title="item.accessId ? 'Edit Access Point Group' : 'New Access Point Group'"
        :saveable="editing"
        class="no-padding"
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <ul class="item-form">
            <li class="form-label-first">
                {{ $t('Group Name') }}
            </li>
            <li>
                <cic-textbox
                    id="group_name"
                    :enabled="editing"
                    :value="item.name"
                    :maxlength="255"
                    @input="(val) => updateFieldValue('name', val)"
                />
            </li>
            <li class="form-label">
                {{ $t('Description') }}
            </li>
            <li>
                <cic-textbox
                    id="group_description"
                    :enabled="editing"
                    :value="item.description"
                    :maxlength="255"
                    @input="(val) => updateFieldValue('description', val)"
                />
            </li>
        </ul>

        <table v-if="item.members.length > 0" id="group_member_table" class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t('Access Point') }}</th>
                    <th>{{ $t('Description') }}</th>
                    <th v-if="editing" class="td-checkbox"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="number in item.members">
                    <td>{{ number.name }}</td>
                    <td>
                        <cic-textbox
                            :enabled="editing"
                            :value="number.description"
                            @input="(val) => updateDescription(number.accessId, val)"
                        />
                    </td>
                    <td v-if="editing">
                        <IconButton icon="remove-icon" @click="handleRemove(number.accessId)" />
                    </td>
                </tr>
            </tbody>
        </table>
    </cic-popup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import IconButton from '@/components/controls/IconButton';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditAccessPointGroup',
        components: {
            CicPopup,
            CicTextbox,
            IconButton,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                editing: false,
            };
        },
        created() {
            this.editing = !this.item.accessId || this.$store.hasRight('EDIT_NUMBER_GROUPS');
        },
        methods: {
            handleRemove(accessId) {
                const members = this.item.members.filter((x) => x.accessId !== accessId);
                this.updateFieldValue('members', members);
            },

            updateDescription(accessId, val) {
                const index = this.item.members.findIndex((x) => x.accessId === accessId);
                const members = [...this.item.members];
                members[index].description = val;
                this.updateFieldValue('members', members);
            },

            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
